// src/data/exercises/L4_02.js

const accountOptions = [
  '現金', '借入金', '貸付金', '手形借入金', '手形貸付金'];

export const L4_02 = {
  title: '簿記　3級（第212-2回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
     parts: [
    { "type": "ruby", "text": "長崎工業株式会社", "ruby": "ながさきこうぎょうかぶしきがいしゃ" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "￥2,500,000を" },
    { "type": "ruby", "text": "貸", "ruby": "か" },
    { "type": "text", "value": "し付け、" },
    { "type": "ruby", "text": "借用証書", "ruby": "しゃくようしょうしょ" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "代用", "ruby": "だいよう" },
    { "type": "text", "value": "として" },
    { "type": "ruby", "text": "同社振出", "ruby": "どうしゃふりだ" },
    { "type": "text", "value": "しの" },
    { "type": "ruby", "text": "約束手形", "ruby": "やくそくてがた" },
    { "type": "text", "value": "を" },
    { "type": "ruby", "text": "受", "ruby": "う" },
    { "type": "text", "value": "け取った。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '現金', debitAmount: 2500000, creditAccount: '手形貸付金', creditAmount: 2500000},
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '①まず、現金を貸すと現金は減る。\n' },
          { type: 'text', value: '現金が減少（マイナス）します。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は、貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、貸したので\n' },
          { type: 'text', value: '貸付金が増加（プラス）しますが、約束手形を受け取ったので\n' },
          { type: 'text', value: '手形貸付金が増加（プラス）します。\n' },
          { type: 'styled', value: '手形貸付金の増加（プラス）は、借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`①まず、現金を貸すと現金は減る。
現金が減少（マイナス）します。

②次に、貸したので
貸付金が増加（プラス）しますが、約束手形を受け取ったので
手形貸付金が増加（プラス）します。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '①まず、現金を貸すと現金は減る。\n' },
          { type: 'text', value: '現金が減少（マイナス）します。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は、貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、貸したので\n' },
          { type: 'text', value: '貸付金が増加（プラス）しますが、約束手形を受け取ったので\n' },
          { type: 'text', value: '手形貸付金が増加（プラス）します。\n' },
          { type: 'styled', value: '手形貸付金の増加（プラス）は、借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};